<template>
  <div>
    <v-dialog v-model="showUpdateItemDialog" max-width="500px" >
      <v-card>
        <v-card-title primary-title>
          <v-layout row wrap>
            <v-flex xs12>
              <h2>{{itemData.serial_number}}</h2>
              <h4>{{routeDescription}}</h4>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-form v-on:submit.prevent="updateItem" v-model="valid" ref="updateItemForm">
            <v-container grid-list-md>
              <v-layout row wrap>
                
                <v-flex class="card-item">
                  <v-layout row wrap>
                    <v-flex xs3>
                      <v-text-field
                        name="whole"
                        label="Completos"
                        id="whole"
                        type="number"
                        v-model="itemData.whole"
                        outline
                        @focus="$event.target.select()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-text-field
                        name="three-quarter"
                        label="Tres Cuartos"
                        id="three-quarter"
                        type="number"
                        v-model="itemData.three_quarter"
                        @focus="$event.target.select()"
                        outline
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-text-field
                        name="half"
                        label="Medio"
                        id="half"
                        type="number"
                        v-model="itemData.half"
                        @focus="$event.target.select()"
                        outline
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-text-field
                        name="one-quarter"
                        label="Un Cuarto"
                        id="one-quarter"
                        type="number"
                        v-model="itemData.quarter"
                        @focus="$event.target.select()"
                        outline
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="payed-price"
                        label="Precio Pagado"
                        id="payed-price"
                        v-model="itemData.payed_price"
                        @focus="$event.target.select()"
                        type="number"
                        outline
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              
                <v-layout row wrap>
                  <v-flex xs5 text-xs-right>
                    <v-btn color="error" @click="closeDialog">Cancelar</v-btn>
                  </v-flex>
                  <v-flex xs5 text-xs-right>
                    <v-btn type="submit" color="success">Actualizar</v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'line-item-update',
  props: [ 'productId', 'routeDescription'],
  data() {
    return {
      hasSerialNumberOptions: [
        {label: 'Si', value: true},
        {label: 'No', value: false},
      ],
      itemData: {
        has_code: true,
        payed_price: 0.00,
        whole: 0,
        three_quarter: 0,
        half: 0,
        quarter: 0,
        serial_number: '',
        weigth: '',
      },
      valid: true,
      showUpdateItemDialog: false,
      product: {},
    };
  },
  computed: {
    currentList() {
      return this.$store.state.user.profile.currentList;
    },
    currentListPercentage() {
      if (this.$store.getters.getProfile && this.$store.getters.getProfile.currentList) {
        return this.$store.getters.getProfile.currentList.percentage / 100;
      }
      return 0;
    },
  },
  watch: {
    productId(val) {
      if (!val || val === 0) {
        this.showUpdateItemDialog = false;
        return;
      }
      this.axios.get(`/po/getLine/${val}`)
      .then( (result) => {
        const data = result.data;
        this.itemData = {
          has_code: data.serial_number ? true : false,
          payed_price: data.payed_price,
          whole: data.whole,
          three_quarter: data.three_quarter,
          half: data.half,
          quarter: data.quarter,
          serial_number: data.serial_number,
          weigth: data.weigth,
        };
        this.showUpdateItemDialog = true;
      })
      .catch( (error) => {
         this.$emit('error', error.message);
      })
      .finally();
    },
    showUpdateItemDialog(val) {
      if (!val){
        this.$emit('close');
      }
    },
  },
  methods: {
    updateItem() {
      if (this.isLineValid()) {
        this.itemData.payed_price = parseFloat(this.itemData.payed_price, 10);

        this.itemData.whole = parseInt( this.itemData.whole, 10);
        this.itemData.three_quarter = parseInt( this.itemData.three_quarter, 10);
        this.itemData.half = parseInt(this.itemData.half, 10);
        this.itemData.quarter = parseInt(this.itemData.quarter, 10);

        this.itemData.type = 'CATALYST';

        this.itemData.units = this.itemData.whole + this.itemData.three_quarter
          + this.itemData.half + this.itemData.quarter;
        this.itemData.pieces = this.itemData.whole + (this.itemData.three_quarter * 0.75 )
          + (this.itemData.half * 0.5) + (this.itemData.quarter * 0.25);

        this.axios.put(`/po/line/${this.productId}`, this.itemData)
        .then( (result) => {
          this.showUpdateItemDialog = false;
          this.$emit('updated', 'Pieza actualizada');
        })
        .catch( (error) => {
          this.showUpdateItemDialog = false;
          this.$emit('error', error.message);
        })
        .finally();
      } else {
        this.$emit('warning', 'Ingrese una cantidad de piezas');
      }
    },
    isLineValid() {
      const hasItems =
        this.itemData.whole > 0 || this.itemData.three_quarter > 0 || this.itemData.half || this.itemData.quarter > 0;
      return hasItems;
    },
    closeDialog() {
      this.showUpdateItemDialog = false;
      this.$emit('close');
    },
  },

};
</script>